import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import './successanim.scss';

class SuccessAnim extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radius: 44,
      ringLength: 2 * Math.PI * 44,
    };
  }

  componentDidMount() {
    const { ringLength } = this.state;

    let length = 1000;

    setTimeout(() => {
        this.setState({tickReady: true});
    }, length);

    let iterations = 1;
    let end;
    let duration;
    const now = moment();

    if (duration) {
      length = duration.asMilliseconds();
    }

    const ringAnim = [
      { strokeDashoffset: `${ringLength || 0}px` },
      { strokeDashoffset: '0px' },
    ];

    const ringTiming = {
      duration: length,
      iterations,
      easing: 'ease-in-out',
      fill: 'forwards',
    };
    const ring = document.getElementById('sa-ring');

    if (ring && length && iterations && ringAnim && ringTiming) {
      ring.animate(
        ringAnim,
        ringTiming,
      );
    }
  }

  render() {
    const { radius, ringLength, tickReady } = this.state;

    const ringStyle = {
      strokeDasharray: ringLength,
      strokeDashoffset: ringLength,
    };

    return (
      <div className="sa-con">
        <div className="sa-ring">
          <svg viewBox="0 0 92 92">
            <circle id="sa-ring" cx="50%" cy="50%" r={radius} strokeWidth="4" style={ringStyle} />
          </svg>
        </div>
        {tickReady && (
          <div className="sa">
            <div className="sa-success">
              <div className="sa-success-tip"></div>
              <div className="sa-success-long"></div>
            </div>
          </div>
        )}
      </div>
    );
  }

}

export default withRouter(SuccessAnim);
